type HastNode = {
  type?: string;
  tagName?: string;
  value?: string;
  properties?: Record<string, unknown>;
  children?: HastNode[];
};

const STREAMING_TEXT_SKIP_TAGS = new Set([
  'code',
  'pre',
  'script',
  'style',
  'svg',
]);

export const streamingTextPlugin = () => (tree: HastNode) => {
  const lastTextParent: { current?: HastNode } = {};

  const walk = (node: HastNode, isBlocked = false) => {
    if (!Array.isArray(node.children)) return;

    const rawClassName = node.properties?.className;
    const classes = Array.isArray(rawClassName)
      ? rawClassName.map(String)
      : typeof rawClassName === 'string'
        ? rawClassName.split(/\s+/)
        : [];
    const blocked = isBlocked
      || STREAMING_TEXT_SKIP_TAGS.has(node.tagName || '')
      || classes.some((className) => className.startsWith('katex'));

    if (blocked) return;

    node.children = node.children.flatMap((child) => {
      if (child.type !== 'text' || typeof child.value !== 'string' || child.value.length === 0) {
        walk(child, blocked);
        return [child];
      }

      const pieces = child.value.match(/\s+|\S+\s*/g) || [child.value];
      return pieces.map((piece): HastNode => {
        if (!piece.trim()) return { type: 'text', value: piece };
        lastTextParent.current = node;
        return {
          type: 'element',
          tagName: 'span',
          properties: { className: ['markdown-stream-token'] },
          children: [{ type: 'text', value: piece }],
        };
      });
    });
  };

  walk(tree);

  if (lastTextParent.current && Array.isArray(lastTextParent.current.children)) {
    lastTextParent.current.children.push({
      type: 'element',
      tagName: 'span',
      properties: { className: ['markdown-stream-caret'] },
      children: [],
    });
  }
};
